import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiRequest } from "../apiService/allapi";
import { successAlert, errorAlert } from "../apiService/sweetAlert";
import { Modal } from "bootstrap";
import { syncGuestCartToServer } from "../helper/cartUtils";

const Account = () => {
  const [token, setToken] = useState(localStorage.getItem("token") || '');
  const [showPassword, setShowPassword] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [forgotEmail, setForgotEmail] = useState("");
  const [loadingForgot, setLoadingForgot] = useState(false);
  // RESSET PASSWORD
  const [confirmationCode, setConfirmationCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loadingReset, setLoadingReset] = useState(false);

  const initialFormState = {
    fullName: "",
    email: "",
    mobile: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    address: "",
    password: "",
    referral: "",
  };

  // Rewards states
  const [rewards, setRewards] = useState({ totalPoints: 0, history: [] });
  const [rewardsLoading, setRewardsLoading] = useState(false);
  const [loginData, setLoginData] = useState({
    loginId: "",
    password: "",
  });
  const handleLoginChange = (e) => {
    setLoginData({
      ...loginData,
      [e.target.id]: e.target.value,
    });
  };

  // STEP 2: Fir useState me use karo
  const [formData, setFormData] = useState(initialFormState);

  const [otp, setOtp] = useState("");
  const [showOtp, setShowOtp] = useState(false);

  // ================= HANDLE CHANGE =================
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ================= SEND OTP =================
  const [loading, setLoading] = useState(false);

  const sendOtp = async () => {
    try {
      setLoading(true);

      let email = formData.email;

      const res = await apiRequest("/Auth/send-otp", "POST", { email });

      // ✅ response check
      if (res?.data?.status === true) {
        setLoading(false);
        successAlert(res.data.message);
        setShowOtp(true);
        return true;
      } else {
        setLoading(false);
        errorAlert(res.data.message);
        setShowOtp(false);
        return false;
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      return false;
    }
  };

  // ================= VERIFY OTP + REGISTER =================
  const handleSubmit = async () => {
    try {
      const payload = {
        email: formData.email,
        otp: otp,
        memberName: formData.fullName,
        mobile: formData.mobile,
        countryID: formData.country,
        stateID: formData.state,
        cityID: formData.city,
        pinCode: formData.pincode,
        cityName: "string",
        address: formData.address,
        password: formData.password,
        referralCode: formData.referral,
      };

      const res = await apiRequest("/Auth/register", "POST", payload);

      if (res?.data?.success === true) {
        successAlert(res.data.message);

        setFormData(initialFormState);
        setOtp("");
        setShowOtp(false);
        setStates([]);
        setCities([]);
      } else {
        errorAlert(res.data.message);
      }
    } catch (error) {
      errorAlert(error.response?.data?.message);
    }
  };
  const getCountries = async () => {
    try {
      const res = await apiRequest("/Common/Country/list", "GET");
      const countryArray = Array.isArray(res.data.data.data)
        ? res.data
        : res.data || [];
      setCountries(res.data.data.data);
    } catch (error) {
      setCountries([]);
    }
  };
  useEffect(() => {
    getCountries();
  }, []);
  const getStates = async (countryId) => {
    try {
      const res = await apiRequest(`/Common/State/${countryId}`, "GET");

      setStates(res.data.data || []);
    } catch (error) {
      setStates([]);
    }
  };
  const getCities = async (stateId) => {
    try {
      const res = await apiRequest(`/Common/api/common/city/${stateId}`, "GET");

      setCities(res.data.data || []);
    } catch (error) {
      setCities([]);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setToken('');
    window.dispatchEvent(new CustomEvent("userLoggedOut"));
  };

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await apiRequest("/Auth/login", "POST", loginData);

      if (res?.data?.success === true) {
      console.log("LOGIN SUCCESS"); // 🔥

        localStorage.setItem("token", res.data.token);
        setToken(res.data.token);
        window.dispatchEvent(new CustomEvent("userLoggedIn"));
              console.log("CALLING SYNC"); // 🔥

        // Sync guest cart to server
await syncGuestCartToServer();  // ✅ correct
              console.log("SYNC DONE"); // 🔥

        successAlert("Login Successful!");
        navigate('/');
      } else {
        errorAlert(res?.data?.message || "Invalid Login Credentials");
      }
    } catch (error) {
      errorAlert(error.response?.data?.message || "Login Failed");
    }
  };

  // forget password api
  const handleForgotPassword = async () => {
    if (!forgotEmail) {
      return;
    }

    try {
      setLoadingForgot(true);

      const res = await apiRequest("/Auth/forgotpassword", "POST", {
        email: forgotEmail,
      });
      if (res?.data?.success === true || res?.data?.status === true) {
        successAlert(res.data.message);

        // Close first modal
        const emailModalElement = document.getElementById("emailModal");
        const emailModalInstance = Modal.getInstance(emailModalElement);
        emailModalInstance.hide();

        // Open second modal
        const resetModalElement = document.getElementById("resetModal");
        const resetModalInstance = new Modal(resetModalElement);
        resetModalInstance.show();
      } else {
        errorAlert(res?.data?.message || "Something went wrong");
      }
    } catch (error) {
      errorAlert(error.response?.data?.message || "Server Error");
    } finally {
      setLoadingForgot(false);
    }
  };
  const handleResetPassword = async () => {
    if (!confirmationCode || !newPassword || !confirmPassword) {
      errorAlert("All fields are required");
      return;
    }

    if (newPassword !== confirmPassword) {
      errorAlert("Passwords do not match");
      return;
    }

    try {
      setLoadingReset(true);

      const res = await apiRequest("/Auth/resetpassword", "POST", {
        confirmationCode: Number(confirmationCode),
        toEmail: forgotEmail, // same email jo pehle use ki thi
        newpassword: newPassword,
        confirmpassword: confirmPassword,
      });

      if (res?.data?.status === true) {
        successAlert(res.data.message);

        // Close reset modal
        const resetModalElement = document.getElementById("resetModal");
        const resetModalInstance =
          Modal.getInstance(resetModalElement) || new Modal(resetModalElement);

        resetModalInstance.hide();

        // Clear fields
        setConfirmationCode("");
        setNewPassword("");
        setConfirmPassword("");
        setForgotEmail("");
      } else {
        errorAlert(res?.data?.message || "Reset failed");
      }
    } catch (error) {
      errorAlert(error.response?.data?.message || "Server Error");
    } finally {
      setLoadingReset(false);
    }
  };

  return (
    <section className="account py-120 bg-color-one">
      <div className="container container-lg">
       
          <>
            <div className="row gy-4 justify-content-center">
              {/* Login */}
              <div className="col-xl-6 pe-xl-5">
                <form onSubmit={handleLogin}>
                  <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40 h-100">
                    <h6 className="text-xl mb-32">Login</h6>
                <div className="mb-24">
                  <label
                    htmlFor="username"
                    className="text-neutral-900 text-lg mb-8 fw-medium"
                  >
                    Username or email address{" "}
                    <span className="text-danger">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className="common-input"
                    id="loginId"
                    value={loginData.loginId}
                    onChange={handleLoginChange}
                    placeholder="Enter Login ID"
                  />
                </div>
                <div className="mb-24">
                  <label
                    htmlFor="password"
                    className="text-neutral-900 text-lg mb-8 fw-medium"
                  >
                    Password
                  </label>
                  <div className="position-relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="common-input"
                      id="password"
                      value={loginData.password}
                      onChange={handleLoginChange}
                      placeholder="Enter Password"
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      className={`toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ${showPassword ? "ph-eye" : "ph-eye-slash"}`}

                    />
                  </div>
                </div>
                <div className="mb-24 mt-48">
                  <div className="flex-align gap-48 flex-wrap">
                    <button type="submit" className="btn btn-main py-18 px-40">
                      Log in
                    </button>
                    {/* <div className="form-check common-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        defaultValue=""
                        id="remember"
                      />
                      <label
                        className="form-check-label flex-grow-1"
                        htmlFor="remember"
                      >
                        Remember me
                      </label>
                    </div> */}
                  </div>
                </div>
                <div className="mt-3">
                  <Link
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#emailModal"
                    className="text-danger-600 text-sm fw-semibold text-decoration-none"
                  >
                    Forgot your password?
                  </Link>
                </div>

                {/* ================= FIRST MODAL (EMAIL) ================= */}
                <div
                  className="modal fade"
                  id="emailModal"
                  tabIndex="-1"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content bg-dark text-white">
                      <div className="modal-header border-0">
                        <h5 className="modal-title">Forgot Password</h5>
                        <button
                          type="button"
                          className="btn-close btn-close-white"
                          data-bs-dismiss="modal"
                        ></button>
                      </div>

                      <div className="modal-body">
                        <input
                          type="email"
                          className="form-control mb-3"
                          placeholder="Enter your email"
                          value={forgotEmail}
                          onChange={(e) => setForgotEmail(e.target.value)}
                        />
                        <button
                          type="button" 
                          className="btn btn-warning w-100"
                          onClick={handleForgotPassword}
                        >
                          {loadingForgot ? "Sending..." : "Send Reset Code"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ================= SECOND MODAL (RESET PASSWORD) ================= */}
                <div
                  className="modal fade"
                  id="resetModal"
                  tabIndex="-1"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content bg-dark text-white p-3 rounded-4">
                      <h4 className="mb-3">Reset Password</h4>
                      <p className="small">
                        A confirmation code has been sent to your registered
                        email address.
                      </p>
                      <input
                        type="text"
                        className="form-control mb-3"
                        placeholder="Confirmation Code"
                        value={confirmationCode}
                        onChange={(e) => setConfirmationCode(e.target.value)}
                      />
                      <input
                        type="password"
                        className="form-control mb-3"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />

                      <input
                        type="password"
                        className="form-control mb-3"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <div className="d-flex justify-content-end gap-3">
                        <button
                          className="btn btn-secondary"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>

                        <button
                          type="button"
                          className="btn btn-warning"
                          onClick={handleResetPassword}
                        >
                          {loadingReset ? "Resetting..." : "Reset"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                </form>
              </div>
              {/* Register */}
              <div className="col-xl-6">
                <form>
                  <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40">
                    <h6 className="text-xl mb-32">Register</h6>

                {/* Full Name */}
                <div className="mb-24">
                  <label className="text-neutral-900 text-lg mb-8 fw-medium">
                    Full Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="common-input"
                    placeholder="Enter Full Name"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                  />
                </div>

                {/* Email */}
                <div className="mb-24">
                  <label className="text-neutral-900 text-lg mb-8 fw-medium">
                    Email Address <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className="common-input"
                    placeholder="Enter Email Address"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>

                {/* Mobile Number */}
                <div className="mb-24">
                  <label className="text-neutral-900 text-lg mb-8 fw-medium">
                    Mobile Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="tel"
                    className="common-input"
                    placeholder="Enter Mobile Number"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                  />
                </div>

                {/* Country */}
                <div className="mb-24">
                  <label className="text-neutral-900 text-lg mb-8 fw-medium">
                    Country <span className="text-danger">*</span>
                  </label>

                  <select
                    className="common-input"
                    name="country"
                    value={formData.country}
                    onChange={(e) => {
                      handleChange(e); 
                      getStates(e.target.value); 
                    }}
                  >
                    <option value="">Select Country</option>

                    {Array.isArray(countries) &&
                      countries.map((item) => (
                        <option key={item.countryID} value={item.countryID}>
                          {item.countryName}
                        </option>
                      ))}
                  </select>
                </div>

                {/* State */}
                <div className="mb-24">
                  <label className="text-neutral-900 text-lg mb-8 fw-medium">
                    State <span className="text-danger">*</span>
                  </label>
                  <select
                    className="common-input"
                    name="state"
                    value={formData.state}
                    onChange={(e) => {
                      handleChange(e);
                      setFormData((prev) => ({
                        ...prev,
                        state: e.target.value,
                        city: "", 
                      }));
                      getCities(e.target.value);
                    }}
                  >
                    <option value="">Select State</option>

                    {states.map((item) => (
                      <option key={item.stateID} value={item.stateID}>
                        {item.stateName}
                      </option>
                    ))}
                  </select>
                </div>

                {/* City */}
                <div className="mb-24">
                  <label className="text-neutral-900 text-lg mb-8 fw-medium">
                    City <span className="text-danger">*</span>
                  </label>
                  <select
                    className="common-input"
                    name="city"
                    value={formData.city}
                    disabled={!formData.state}
                    onChange={handleChange}
                  >
                    <option value="">Select City</option>

                    {cities.map((item) => (
                      <option key={item.cityID} value={item.cityID}>
                        {item.cityName}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Pincode */}
                <div className="mb-24">
                  <label className="text-neutral-900 text-lg mb-8 fw-medium">
                    Pincode <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="common-input"
                    placeholder="Enter Pincode"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleChange}
                  />
                </div>

                {/* Address */}
                <div className="mb-24">
                  <label className="text-neutral-900 text-lg mb-8 fw-medium">
                    Address <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="common-input"
                    placeholder="Enter Full Address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                  ></textarea>
                </div>

                {/* Password */}
                <div className="mb-24">
                  <label className="text-neutral-900 text-lg mb-8 fw-medium">
                    Password <span className="text-danger">*</span>
                  </label>
                  <div className="position-relative">
                    <input
                      type="password"
                      className="common-input"
                      placeholder="Enter Password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                    />
                    <span className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ph-eye-slash"></span>
                  </div>
                </div>

                {/* Referral Code */}
                <div className="mb-24">
                  <label className="text-neutral-900 text-lg mb-8 fw-medium">
                    Referral Code (Optional)
                  </label>
                  <input
                    type="text"
                    className="common-input"
                    placeholder="Enter Referral Code"
                    name="referral"
                    value={formData.referral}
                    onChange={handleChange}
                  />
                </div>

                {/* Privacy Text */}
                <div className="my-48">
                  <p className="text-gray-500">
                    Your personal data will be used to process your order,
                    support your experience throughout this website, and for
                    other purposes described in our
                    <Link
                      to="#"
                      className="text-main-600 text-decoration-underline"
                    >
                      {" "}
                      privacy policy
                    </Link>
                    .
                  </p>
                </div>

                {/* Submit Button */}
                {/* OTP INPUT */}
                {showOtp && (
                  <div className="mb-24">
                    <label className="text-neutral-900 text-lg mb-8 fw-medium">
                      Enter OTP
                    </label>
                    <input
                      type="text"
                      className="common-input"
                      placeholder="Enter OTP"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </div>
                )}

                {/* BUTTON */}
                {!showOtp ? (
                  <button
                    type="button"
                    onClick={() => {
                      sendOtp();
                    }}
                    className="btn btn-main py-18 px-40"
                  >
                    {loading ? "Sending OTP..." : "Register"}
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="btn btn-main py-18 px-40"
                  >
                    Verify OTP & Register
                  </button>
                )}
              
                </div>
            {/* Register Card End */}
          
              
                </form>
              </div>
            </div>
          </>
        
      </div>
    </section>
  );
};

export default Account;

